import React, { useEffect, useState } from 'react';
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import PropTypes from "prop-types";
import { formatDate } from "../includes/utils";

export function CsfPivotalFournisseurRecognitionHistory({ formHistory, setTrainingIdPrint }) {

  const langcode = document.documentElement.lang;
  const [startRow, setStartRow] = useState(1);
  const [total, setTotal] = useState(1);
  const [slicedFilteredHistory, setSlicedFilteredHistory] = useState([]);
  const offset = 3;

  useEffect(() => {
    // Set filtered only after props are received
    setTotal(formHistory.length);
    if (formHistory && formHistory.length > 0) {
      setSlicedFilteredHistory(formHistory.slice((startRow - 1), (startRow + offset) - 1));
    }
  }, [formHistory]);

  useEffect(() => {
    setSlicedFilteredHistory(formHistory.slice((startRow - 1), (startRow + offset) - 1));
  }, [startRow]);

  const onClick = (e, prop) => {
    e.persist();
    setTrainingIdPrint(prop);
    document.querySelector('.print-confirmation').classList.add('show');
    document.querySelector('.print-recognition').classList.remove('show');
    setTimeout(function(){
      window.print();
    },200) ;
  };

  return (
    <div className="primary recognition-history d-flex flex-column">
      <h2>{window.Drupal.t('fournisseur.recognition.detail.history.title')}</h2>

      {slicedFilteredHistory && slicedFilteredHistory.length === 0 ? (
        <div>
          <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
        </div>
      ) : (
        slicedFilteredHistory.map((val) => (
          <div className="inner-wrapper" key={`detail-history-${val.REDU_Activity__Cycle_Id}`}>
            <div className="row align-items-center">
              <div className="col-md-4 col-xl-3">
                <h3 className="recognition-title" style={{ lineHeight: "22px" }}>
                  <span>#{val.NoReconnaissance} - </span>
                  <span className="recognition-title-last">{val.Recognition_Type}</span>
                </h3>
              </div>
              <div className="recognition-info col-md-8 col-xl-5" style={{ paddingLeft: 20, lineHeight: "20px" }}>
                <span>{langcode === 'fr' ? val.Name_French : val.Name_English}</span>
                {val.EP_LastEditDate && (
                  <span dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.last.modification.date') + ' ' + formatDate(val.EP_LastEditDate) }}></span>
                )}
              </div>
              <div className="col-md-12 col-xl-4" style={{ paddingLeft: 26 }}>
                {val.Name_French === 'Reconnue - Active' && (
                  <button className='button btn-outlined btn-with-icon' onClick={(e) => onClick(e, val.REDU_Activity__Cycle_Id)}>
                    {window.Drupal.t('fournisseur.recognition.detail.history.confirm')}
                    <i className="icon icon-print supplier-icon"><span className="d-none">&nbsp;</span></i>
                  </button>
                )}
              </div>
            </div>
          </div>
        )))}
      <div className="pagination-wrapper smaller-wrapper">
        <CsfFournisseurPagination
          startRow={startRow}
          offset={offset}
          total={total}
          setStartRowFunction={setStartRow}
        />
      </div>
    </div>
  );
}

CsfPivotalFournisseurRecognitionHistory.propTypes = {
  formHistory: PropTypes.array.isRequired,
  setTrainingIdPrint: PropTypes.func.isRequired
};
